/* eslint-disable no-throw-literal */
import ApiService from 'app/services/ApiService';

export const EVALUATIONS_SUCCESS = 'EVALUATIONS_SUCCESS';
export const EVALUATIONS_BEGIN = 'EVALUATIONS_BEGIN';
export const EVALUATIONS_FAILURE = 'EVALUATIONS_FAILURE';
export const CLEAR_EVALUATIONS = 'CLEAR_EVALUATIONS';

export const EXPORT_EVALUATIONS_SUCCESS = 'EXPORT_EVALUATIONS_SUCCESS';
export const EXPORT_EVALUATIONS_BEGIN = 'EXPORT_EVALUATIONS_BEGIN';
export const EXPORT_EVALUATIONS_FAILURE = 'EXPORT_EVALUATIONS_FAILURE';
export const CLEAR_EXPORT_EVALUATIONS = 'CLEAR_EVALUATIONS';

export const EVALUATIONS_FILTERS_SUCCESS = 'EVALUATIONS_FILTERS_SUCCESS';
export const EVALUATIONS_FILTERS_BEGIN = 'EVALUATIONS_FILTERS_BEGIN';
export const EVALUATIONS_FILTERS_FAILURE = 'EVALUATIONS_FILTERS_FAILURE';
export const CLEAR_EVALUATIONS_FILTERS = 'CLEAR_EVALUATIONS_FILTERS';

export const EVALUATIONS_AVALIABLE_TEST_SUCCESS = 'EVALUATIONS_AVALIABLE_TEST_SUCCESS';
export const EVALUATIONS_AVALIABLE_TEST_BEGIN = 'EVALUATIONS_AVALIABLE_TEST_BEGIN';
export const EVALUATIONS_AVALIABLE_TEST_FAILURE = 'EVALUATIONS_AVALIABLE_TEST_FAILURE';
export const CLEAR_EVALUATIONS_AVALIABLE_TEST = 'CLEAR_EVALUATIONS_AVALIABLE_TEST';

export const USERS_EVALUATIONS_SUCCESS = 'EVALUATIONS_SUCCESS';
export const USERS_EVALUATIONS_BEGIN = 'EVALUATIONS_BEGIN';
export const USERS_EVALUATIONS_FAILURE = 'EVALUATIONS_FAILURE';
export const CLEAR_USERS_EVALUATIONS = 'CLEAR_EVALUATIONS';

export const EVALUATIONS_CAL_SUCCESS = 'EVALUATIONS_CAL_SUCCESS';
export const EVALUATIONS_CAL_BEGIN = 'EVALUATIONS_CAL_BEGIN';
export const EVALUATIONS_CAL_FAILURE = 'EVALUATIONS_CAL_FAILURE';
export const CLEAR_EVALUATIONS_CAL = 'CLEAR_EVALUATIONS_CAL';

export const EVALUATIONS_CAL_FILTERS_SUCCESS = 'EVALUATIONS_CAL_FILTERS_SUCCESS';
export const EVALUATIONS_CAL_FILTERS_BEGIN = 'EVALUATIONS_CAL_FILTERS_BEGIN';
export const EVALUATIONS_CAL_FILTERS_FAILURE = 'EVALUATIONS_CAL_FILTERS_FAILURE';
export const CLEAR_EVALUATIONS_CAL_FILTERS = 'CLEAR_EVALUATIONS_CAL_FILTERS';

export const EVALUATIONS_EXPORTING_BEGIN = 'EVALUATIONS_EXPORTING_BEGIN';
export const EVALUATIONS_EXPORTING_FINISH = 'EVALUATIONS_EXPORTING_FINISH';




export const getEvaluationsCalFtF_ = (params) => dispatch => {
    dispatch({
        type: EVALUATIONS_CAL_BEGIN,
    });

    ApiService.getEvaluationFacetoFacePrinted(params)
        .then(
            result => {
                dispatch({
                    type: EVALUATIONS_CAL_SUCCESS,
                    payload: result
                })
            },
            error => {
                dispatch({
                    type: EVALUATIONS_CAL_FAILURE,
                })
                throw ({ error: error, message: 'An error ocurred' });
            }
        )
}

export const exportEvaluationCalFtF_ = (param, title) => dispatch => {
    let objValidate = {}

    for (const [key, value] of Object.entries(param)) {
        if (value) {
            objValidate[key] = value
        }
    }
    ApiService.getExportEvaluationFacetoFacePrinted(objValidate).then(
        result => {
            const blob = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            downloadFile(blob, `Resultados_de_Evaluaciones_Presenciales${title}.xlsx`);
        }
    ).catch(
        (error) =>
            console.log(error)
    )
}

export const getEvaluationsCalFiltersFtF = (params) => dispatch => {

    dispatch({
        type: EVALUATIONS_CAL_FILTERS_BEGIN,
    });
    ApiService.getEvaluationFacetoFacePrintedFilters(params)
        .then(
            result => {
             
                dispatch({
                    type: EVALUATIONS_CAL_FILTERS_SUCCESS,
                    payload: { result }
                });
            },
            error => {
                dispatch({
                    type: EVALUATIONS_CAL_FILTERS_FAILURE,
                });
                throw ({ error: error, message: 'An error ocurred' });
            }
        )

}

export const editEvaluationCalFtF = (param, title, callback) => dispatch => {
    let objValidate = {}

    for (const [key, value] of Object.entries(param)) {
        if (value) {
            objValidate[key] = value
        }
    }



    ApiService.setEvaluationFacetoFaceCalEstatus(objValidate).then(
        result => {
            dispatch(getEvaluationsCalFtF_(title))
            if (typeof callback === 'function') {
                callback();
            }
        }
    ).catch(
        (error) => {

            throw ({ error: error, message: 'An error ocurred' });
        }
    )
}


export const exportEvaluationFtF = (param, title, callback) => dispatch => {
    let objValidate = {}
    // dispatch({
    //     type: EVALUATIONS_EXPORTING_BEGIN,
    // });

    for (const [key, value] of Object.entries(param)) {
        if (value) {
            objValidate[key] = value
        }
    }
    ApiService.getExportEvaluationFacetoFace(objValidate).then(
        result => {
            // dispatch({
            //     type: EVALUATIONS_EXPORTING_FINISH,
            // });
            const blob = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            downloadFile(blob, `Evaluacion_${title}.xlsx`);
            if (typeof callback === 'function') {
                callback();
            }
          
        }
    ).catch(
        (error) => {
            // dispatch({
            //     type: EVALUATIONS_EXPORTING_FINISH,
            // });
            if (typeof callback === 'function') {
                callback();
            }
            throw ({ error: error, message: 'An error ocurred' });
        }


    )
}

export const getEvaluationsFtF = (params) => dispatch => {
    dispatch({
        type: EVALUATIONS_BEGIN,
    });

    ApiService.getEvaluationFacetoFace(params)
        .then(
            result => {
                dispatch({
                    type: EVALUATIONS_SUCCESS,
                    payload: result
                })
            },
            error => {
                dispatch({
                    type: EVALUATIONS_FAILURE,
                })
                throw ({ error: error, message: 'An error ocurred' });
            }
        )
}


export const getEvaluationsFiltersFtF = (params) => dispatch => {
    dispatch(onSiteEvaluationsFiltersBegin());
    ApiService.getEvaluationFacetoFaceFilters(params)
        .then(
            result => {
                dispatch(onSiteEvaluationsFiltersSuccess(result));
            },
            error => {
                dispatch(onSiteEvaluationsFiltersError());
                throw ({ error: error, message: 'An error ocurred' });
            }
        )

}

export const getEvaluationsFtFTests = (params) => dispatch => {
    return async dispatch => {
        await ApiService.getEvaluationFacetoFaceTests(params.model, params.id)
            .then(
                result => {
                    console.log(result)
                },
                error => {
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export const getEvaluationsFtFTestsAvailable = (params) => dispatch => {
    return async dispatch => {
        await ApiService.getEvaluationFacetoFaceTestsAvailables(params.model, params.course, params.training)
            .then(
                result => {
                    console.log(result)
                },
                error => {
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export const getAsignedEmployeesFtF = async (params) => {
    var response = await ApiService.getAsignedEmployeeEvaluationFaceToFace(params);

    return response

    // .then(
    //     result => {
    //         return result;
    //     },
    //     error => {
    //         throw ({ error: error, message: 'An error ocurred' });
    //     }
    // )
}

export const printEvaluationFtF = (param, title) => dispatch => {
    let objValidate = {}

    for (const [key, value] of Object.entries(param)) {
        if (value) {
            objValidate[key] = value
        }
    }
    ApiService.postPrintEvaluation(objValidate).then(
        result => {
            const blob = new Blob([result], { type: 'application/pdf' });
            downloadFile(blob, `Evaluacion_${title}.pdf`);
        }
    ).catch(
        (error) =>
            console.log(error)
    )
}

//postPrintEvaluation

const downloadFile = (blob, fileName) => {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.append(link);
    link.click();
    link.remove();
    window.addEventListener('focus', e => URL.revokeObjectURL(link.href), { once: true });
};

export const onSiteEvaluationsFiltersBegin = () => ({
    type: EVALUATIONS_FILTERS_BEGIN,
});
export const onSiteEvaluationsFiltersSuccess = data => ({
    type: EVALUATIONS_FILTERS_SUCCESS,
    payload: { data }
})
export const onSiteEvaluationsFiltersError = () => ({
    type: EVALUATIONS_FILTERS_FAILURE,
})
export const clearOnSiteEvaluationsFilters = () => ({
    type: CLEAR_EVALUATIONS_FILTERS,
})

export const clearOnSiteEvaluationsCalFilters = () => ({
    type: CLEAR_EVALUATIONS_CAL_FILTERS,
})